module.exports = __webpack_public_path__ + "static/kitty-ann_PLACEHOLDER-1b3edba6ccb377295bef0440101126ca.jpg";